import { cloneDeep, isEqual, upperFirst } from 'lodash'

export const core = options => {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    computed: {
      validation() {
        return true
      },
      loading() {
        return options.loading?.update?.[options.path]
      },
      disabled() {
        if (this.loading) {
          return true
        }
        if (this.proxyIsChanged) {
          return !this.validation
        } else {
          return true
        }
      }
    },

    methods: {
      submit() {
        if (!this.disabled) {
          this.$emit('input', this._outputFilter(this.proxy))
          this.initProxy = cloneDeep(this.proxy)
        }
      },

      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    }
  }
}

export const confirmFields = (options, fields) => {
  const { path, loading, settings, defaults } = options

  return {
    name: path.split('.').map(upperFirst).join(''),

    data() {
      const initProxy = {}
      const proxy = {}

      for (const field of fields) {
        const key = this.getKey(field)
        const setting = settings?.[key]

        initProxy[field] = cloneDeep(setting)
        proxy[field] = cloneDeep(setting)
      }

      return {
        fields,
        initProxy,
        proxy
      }
    },

    methods: {
      getKey(field) {
        return [ path, field ].filter(Boolean).join('.')
      },
      getLoading(field) {
        const key = this.getKey(field)

        return loading?.update?.[key]
      },
      getComparableValue(field, value) {
        if (value === undefined || value === null) {
          const key = this.getKey(field)
          const defaultValue = defaults?.[key]

          return defaultValue
        }

        return cloneDeep(value)
      },
      getDisabled(field) {
        const fieldLoading = this.getLoading(field)
        if (fieldLoading) {
          return true
        }

        const initData = this.getComparableValue(field, this.initProxy[field])
        const currentData = this.getComparableValue(field, this.proxy[field])

        if (isEqual(initData, currentData)) {
          return true
        }

        return false
      },
      submitField(field, value) {
        const normalizedValue = this.getComparableValue(field, value)

        this.initProxy[field] = cloneDeep(normalizedValue)
        this.proxy[field] = cloneDeep(normalizedValue)
      }
    }
  }
}
